import { render, staticRenderFns } from "./PrintHoldpoint.vue?vue&type=template&id=4faa0a52"
import script from "./PrintHoldpoint.vue?vue&type=script&lang=js"
export * from "./PrintHoldpoint.vue?vue&type=script&lang=js"
import style0 from "./PrintHoldpoint.vue?vue&type=style&index=0&id=4faa0a52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports